// src/js/components/Evaluation/ResultsDownloadForm.js
import React, { Component } from "react";
import { connect } from "react-redux";

import './ResultsDownloadForm.css';
import {updateFormField, submitForm} from "../../actions";

const mapStateToProps = state => {
    return {
        displayresults: state.displayresults,
        form : state.form,
        formerrors : state.formerrors,
        formvalid : state.formvalid,
        formsent : state.formsent
    };
};

function mapDispatchToProps(dispatch) {
    return {
        updateFormField: payload => dispatch(updateFormField(payload)),
        submitForm : payload => dispatch(submitForm(payload))
    };
}

class ConnectedResultsDownloadForm extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.formSubmit = this.formSubmit.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if(this.props.displayresults && !this.props.formsent) {
            let el = document.getElementById('evDownloadCurtain');
            el.classList.remove('display');
        }
    }

    handleChange(e){
        this.props.updateFormField({ name: e.target.name , value: e.target.value })
    }

    formSubmit() {
        let el = document.getElementById('evDownloadCurtain');
        el.classList.add('display');
        this.props.submitForm();
    }

    render() {
        if(this.props.displayresults) {
            if(!this.props.formsent) {
                return (
                    <div className="evapDownloadContainer" id="emailresultsform">
                        <div className="evDownloadTitleContainer">
                            <div className="evDownloadTitle">
                                Download your results and example action plan
                            </div>
                            <div className="evDownloadClear"></div>
                        </div>
                        <div id="evContent" className="evDownloadTitleContent">
                            <div className="evDownloadIntro">
                                To receive a copy of your results and the sample action plan from this survey, please provide the following details and we will email you a link to download.
                            </div>
                            <FormErrors display={this.props.formvalid}/>
                            <div>
                                <InputField fname="firstname" fvalue={this.props.firstname}
                                            ferror={this.props.formerrors.firstname} fOnChangefn={this.handleChange}
                                            fplaceholder="First Name *"/>
                                <InputField fname="lastname" fvalue={this.props.lastname}
                                            ferror={this.props.formerrors.lastname} fOnChangefn={this.handleChange}
                                            fplaceholder="Last Name *"/>
                                <InputField fname="email" fvalue={this.props.email} ferror={this.props.formerrors.email}
                                            fOnChangefn={this.handleChange} fplaceholder="Email *"/>
                                <InputField fname="phone" fvalue={this.props.phone} ferror={this.props.formerrors.phone}
                                            fOnChangefn={this.handleChange} fplaceholder="Phone *"/>
                                <InputField fname="organisation" fvalue={this.props.organisation}
                                            ferror={this.props.formerrors.organisation} fOnChangefn={this.handleChange}
                                            fplaceholder="Company / Organisation *"/>
                                <InputField fname="jobtitle" fvalue={this.props.jobtitle}
                                            ferror={this.props.formerrors.jobtitle} fOnChangefn={this.handleChange}
                                            fplaceholder="Your Job Title *"/>
                            </div>
                            <div className="evDownloadDisclaimer">
                                * Required field.<br/>
                                By completing this form and requesting a download link to your results, you are agreeing to allow us to email your download link, and potentially contact you in future.
                            </div>
                            <div className="evDownloadButtonContainer">
                                <div className="evDownloadButton" id="evDownloadButton" onClick={this.formSubmit}>
                                    Download now &gt;
                                </div>
                                <div className="evDownloadClear"></div>
                            </div>
                            <div className="evDownloadCurtain" id="evDownloadCurtain"><div>Request in progress, please wait</div></div>
                        </div>
                    </div>
                )
            } else {
                return (
                    <div className="evapDownloadContainer" id="emailresults">
                        <div className="evDownloadTitleContainer">
                            <div className="evDownloadTitle">
                                Request a downloadable copy of your results
                            </div>
                            <div className="evDownloadClear"></div>
                        </div>
                        <div>
                            <div className="evDownloadIntro">
                                Thank you for requesting a copy of your evaluation results and the example action plan.<br/><br/>
                                Your request has been received and an email with details of how to download your results will be sent to you shortly.
                            </div>
                        </div>
                    </div>
                )
            }
        } else {
            return null
        }
    }
}

const ResultsDownloadForm = connect(mapStateToProps,mapDispatchToProps)(ConnectedResultsDownloadForm);

export default ResultsDownloadForm;

function InputField(props) {
    return (
        <div className="evDownloadInputContainer">
            <input type="text" className={`evDownloadInput ${props.ferror}`} name={props.fname} value={props.fvalue} onChange= {props.fOnChangefn} placeholder={props.fplaceholder} />
        </div>
    )
}

function FormErrors(props) {
    if (props.display !== true) {
        return (
            <div className="evDownloadErrorMessage">
                An error has occurred when submitting your request, please correct and/or complete the highlighted fields with valid information
            </div>
        )
    }
    return null
}
